import { tMap } from '@app/i18n';
import { TTag } from '@app/models';
import { FC } from 'react';

import './tag.scss';

type TagProps = TTag;

export const Tag: FC<TagProps> = ({ name }) => {
  return <div className="tag">#{tMap(name)}</div>;
};
